/* global APPLE_CLIENT_ID, APPLE_REDIRECT_URI */
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import AppleSignin from 'react-apple-signin-auth'
import { appleLoginCallbackDispatch as dispatchSelector } from 'reduxModules/auth/dispatchers'
import './styles.css'

// AppleSignin (react-apple-signin-auth) is a thin wrapper over Apple's
// runtime-loaded appleid.auth.js. Unlike the Google Identity Services button
// (which renders inside a Google-owned iframe we can't restyle), Apple renders a
// real DOM button, so the wrapper CSS sizes it to match the sibling
// Facebook/OpenAthens buttons directly — no width-measuring hack needed.
//
// onSuccess receives the full Apple response: `authorization.id_token` is the
// JWT (D1); `user` (name/email) is present only on the FIRST authorization (D4).
// The connector forwards both. onError is swallowed to match the other social
// buttons (a cancelled popup is not an app error). With usePopup, Apple only
// resolves onSuccess when redirectURI's origin matches window.location.origin.
export function AppleSignIn({ appleLoginCallback }) {
  // Without a Services ID the Apple SDK errors out; render nothing until
  // APPLE_CLIENT_ID is configured (the Apple Developer console ops step),
  // mirroring the GoogleSignIn guard.
  if (!APPLE_CLIENT_ID) return null

  return (
    <div className="apple-login-wrapper">
      <AppleSignin
        authOptions={{
          clientId: APPLE_CLIENT_ID,
          redirectURI: APPLE_REDIRECT_URI,
          scope: 'name email', // required for Apple to return the first-login `user`
          state: 'swsca',
          usePopup: true
        }}
        uiType="dark"
        className="apple-auth-btn"
        buttonExtraChildren="Continue with Apple"
        // the library's own aria-label ("Signin with apple ID") would hide the
        // visible text from assistive tech; the name must match the label
        aria-label="Continue with Apple"
        onSuccess={appleLoginCallback}
        onError={() => {}}
      />
    </div>
  )
}

AppleSignIn.propTypes = {
  appleLoginCallback: PropTypes.func.isRequired
}

export default connect(null, dispatchSelector)(AppleSignIn)
